// third-party
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data: null
};

const slice = createSlice({
    name: 'data',
    initialState
});

// Reducer
export default slice.reducer;
